import React, { Component } from "react";
import EditableTable from "@components/Table/EditableTable";
import { connect } from "react-redux";
import { api } from "@redux/api";
import { FunctionalFormColumns, createFunctionalFormColumns, functionformProps } from "@containers/management/FunctionalForm/FunctionalFormColumns";
import { FunctionalFormFormFields } from "@containers/management/FunctionalForm/FunctionalFormFields";
import { useAuth, AUTH_LEVEL } from "@/hooks/use-auth";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const CREATE_FORM_PATH = "/admin/create-form";

class FunctionalForm extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      data: [],
      name: "",
      isLoading: false,
      query: null,
      tableRef: null,
    };
  }

  handleCreateFunctionalForm = (body) => {
    return api.createForm(body).then((response) => response.data).catch((error) => error);
  };

  handleDeleteFunctionalForm = (id) => {
    return api.deleteForm(id).then((response) => response.data).catch((error) => error);
  };

  handleBulkDelete = (body) => {
    let payload;
    if (Array.isArray(body)) {
      payload = {
        ids: body.map((r) => (r != null && typeof r === "object" ? r.id : r)).filter((id) => id != null),
      };
    } else {
      payload = body;
    }
    return api.bulkDeleteForms(payload).then((response) => response.data).catch((error) => error);
  };

  handOnlineSave = (key, row) => {
    return api.editForm(key, row).then((response) => response).catch((error) => error);
  };

  handleFilter = (query) => {
    this.setState({
      isLoading: true,
    });
    const fixedQuery = this.props.fixedFormType
      ? `form_type=${this.props.fixedFormType}${query ? `&${query}` : ""}`
      : (query || "");
    return api
      .filterForms(fixedQuery)
      .then((response) => {
        const dataSource = response.data.results;
        return {
          data: dataSource,
          success: true,
          total: response.data.count,
        };
      })
      .catch((error) => error);
  };

  getFunctionalForm = (data) => {
    this.setState({
      isLoading: false,
      data,
    });
  };

  refresh = (needRequest) => {
    return this.tableRef?.current?.refresh(needRequest);
  };

  renderSearches = () => {};
  gettableRef = (tableRef) => {
    console.log("tableRef", tableRef);
    this.setState({
      tableRef,
    });
  };

  render() {
    return (
      <div>
        <EditableTable
          ref={this.tableRef}
          columns={this.props.columns || FunctionalFormColumns}
          data={this.state.data}
          columnProps={functionformProps}
          formFields={FunctionalFormFormFields(this.state.tableRef)}
          getRecord={this.getFunctionalForm}
          createRecords={this.handleCreateFunctionalForm}
          deleteRecord={this.handleDeleteFunctionalForm}
          bulkInsert={this.handleBulkInsert}
          bulkDelete={this.handleBulkDelete}
          handOnlineSave={this.handOnlineSave}
          handleFilter={this.handleFilter}
          postComment={this.handlePostComment}
          renderFilter={this.renderFilter}
          hide_search={true}
          isRowClickable={false}
          isRelated={false}
          isAttachments={false}
          setFilters={this.setFilters}
          filterDescription={this.state.filterDescription}
          getFormRef={this.gettableRef}
          hide_imports={true}
          formClassName={"flex-form"}
          hid_new={!this.props.canWrite}
          canDelete={this.props.canFullAccess}
          new_text={this.props.newText || "Create Form"}
          onNew={() => this.props.navigate(this.props.createPath || CREATE_FORM_PATH)}
          onDoubleClick={(record) => this.props.navigateAndCloseTabs(
            `${this.props.detailPath || "/admin/forms-detail"}/${record.id}`,
            `${this.props.detailPath || "/admin/forms-detail"}/`
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

const withHooks = (Component) => {
  const NewComponent = (props) => {
    const permissionCode = props.permissionCode || "functionform";
    const canWrite = useAuth(permissionCode, AUTH_LEVEL.WRITE);
    const canFullAccess = useAuth(permissionCode, AUTH_LEVEL.FULL_ACCESS);
    const { navigate, navigateAndCloseTabs } = useSmartNavigate();
    const columns = props.columns || (props.fixedFormType
      ? createFunctionalFormColumns({
          detailPath: props.detailPath,
          hideFormType: true,
          hideEquipmentCategory: true,
        })
      : FunctionalFormColumns);
    return (
      <Component
        {...props}
        canWrite={canWrite}
        canFullAccess={canFullAccess}
        navigate={navigate}
        navigateAndCloseTabs={navigateAndCloseTabs}
        columns={columns}
      />
    );
  };
  return NewComponent;
};

export default withHooks(
  connect(mapStateToProps, mapDispatchToProps)(FunctionalForm)
);
